export const HIDDEN = "HIDDEN";
export const OK = "OK";
export const YES_NO = "YES_NO";